import { EN } from './en';
import type { Language } from './Language';
import { SK, type MessageKey } from './sk';

export type TranslationParameters = Record<string, string | number>;

export type Translate = (key: MessageKey, parameters?: TranslationParameters) => string;

/** Looks a key up in the language asked for, falls back to Slovak, and substitutes `{name}` placeholders. */
export const translate = (
  language: Language,
  key: MessageKey,
  parameters: TranslationParameters = {},
): string => {
  const text: string = (language === 'en' ? EN[key] : undefined) ?? SK[key];

  return Object.entries(parameters).reduce(
    (rendered: string, [name, value]) => rendered.split(`{${name}}`).join(String(value)),
    text,
  );
};
